import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CustomCheckbox from "../CustomCheckbox";
import { showGrade, showClass } from "../../utils/textUtils";
import StudentSearchBar from "../../features/student/components/StudentSearchBar";
import FilterPanel from "./FilterPanel";

const FilteredStudentList = ({
  filteredStudents,
  selectedStudents,
  handleSelectStudent,
  handleSelectAllStudent,
  handleFilter,
  levelId = null,
}) => {
  const { levels } = useSelector((state) => state.student);

  const gradeOptions = Array.from({ length: 12 }, (_, i) => i + 1);
  const levelOptions = [
    ...(levelId === null
      ? levels
      : levels.filter((level) => level.id !== parseInt(levelId, 10))),
    { id: 0, name: "클래스 미배정" },
  ];

  const [keyword, setKeyword] = useState("");
  const [gradeList, setGradeList] = useState(gradeOptions);
  const [levelList, setLevelList] = useState(levelOptions);

  const handleFiltering = () => {
    handleFilter({
      keyword: keyword,
      gradeList: gradeList,
      levelList: levelList,
    });
  };

  useEffect(() => {
    handleFiltering();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gradeList, levelList]);

  return (
    <div style={{ display: "flex" }}>
      <div style={{ flex: 1, overflowY: "auto", maxHeight: "520px" }}>
        <FilterPanel
          gradeOptions={gradeOptions}
          levelOptions={levelOptions}
          gradeList={gradeList}
          levelList={levelList}
          setGradeList={setGradeList}
          setLevelList={setLevelList}
          handleFilter={handleFiltering}
        ></FilterPanel>
      </div>
      <div style={{ flex: 3 }}>
        <StudentSearchBar
          width="96%"
          handleFilter={handleFiltering}
          keyword={keyword}
          setKeyword={setKeyword}
        />
        <div
          style={{
            borderRadius: "5px",
            overflow: "auto",
            maxHeight: "457px",
          }}
        >
          {/* 테이블 헤더 */}
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <colgroup>
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "20%" }} />
              <col />
            </colgroup>
            <thead>
              <tr
                style={{
                  borderBottom: "1px solid #EBEBEB",
                  textAlign: "left",
                  top: 0,
                  zIndex: 1,
                }}
              >
                <td style={{ padding: "10px", textAlign: "center" }}>
                  {/* 전체 선택/해제 체크박스 */}
                  {handleSelectAllStudent && (
                    <CustomCheckbox
                      checked={
                        filteredStudents.length > 0 &&
                        filteredStudents.every((student) =>
                          selectedStudents.some((s) => s.id === student.id)
                        )
                      }
                      onChange={(e) =>
                        handleSelectAllStudent(e.target.checked, true)
                      }
                    />
                  )}
                </td>
                <td style={{ padding: "10px" }}>학년</td>
                <td style={{ padding: "10px" }}>이름</td>
                <td style={{ padding: "10px" }}>반</td>
              </tr>
            </thead>
            <tbody style={{ color: "black", fontSize: "18px" }}>
              {filteredStudents.map((student) => (
                <tr key={student.id}>
                  <td style={{ padding: "10px", textAlign: "center" }}>
                    <CustomCheckbox
                      checked={selectedStudents.some(
                        (s) => s.id === student.id
                      )}
                      onChange={() => handleSelectStudent(student)}
                    />
                  </td>
                  <td style={{ padding: "10px" }}>
                    {showGrade(student.grade)}
                  </td>
                  <td style={{ padding: "10px" }}>{student.name}</td>
                  <td style={{ padding: "10px" }}>
                    {showClass(student.level_list)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FilteredStudentList;
